// Classe di utilità: Bantoa
// Gestisce il caricamento del tracker Bantoa e la ricerca visuale tramite componente custom.
// Attributi richiesti per BantoaSearch:
// - data-position: posizione richiesta dal componente
// Dipendenze: script esterno Bantoa, ShopifyTheme.customEvent
// Limiti: richiede presenza di attributi specifici e script esterno funzionante
// Utilizzato per integrare funzionalità di tracking e visual search di Bantoa
window.isBantoaLoaded = false;

// qui attacchiamo il tracker di Bantoa che serve purtroppo per tutto il resto
class Bantoa {
  static EVENTS = {
    LOADED: "bantoa_loaded",
  }

  init = () => {
    const self = this;
    !function(t,n,e,a,c,o,r,s){t.BantoaTrackerObject=c,t[c]=t[c]||function(){(t[c].q=t[c].q||[]).push(arguments)},
    t[o]=t[o]||function(){(t[o].q=t[o].q||[]).push(arguments)},
    r=n.createElement(e),s=n.getElementsByTagName(e)[0],r.async=1, r.onload=self.started, r.src=a,s.parentNode.insertBefore(r,s)}
    (window,document,"script","https://www.bantoa.com/bantoa.tk.min.js?apikey=NTE4X2JhbnRvYWtleQ==","bnt_t","bnt_r_ai");
  }

  started = () => {
    window.isBantoaLoaded = true;
    ShopifyTheme.customEvent(Bantoa.EVENTS.LOADED);
  }
}

// questo gestisce il visual search, in pratica al click sul componente ti fa caricare immagine e poi fa partire il visual search con l'immagine caricata (base64)
// Web Component: BantoaSearch
// Permette di avviare la ricerca visuale tramite click o parametro URL
class BantoaSearch extends HTMLElement {

  connectedCallback() {
    if(!this.dataset.position){
      console.error("BantoaSearch: No position found in the element.");
      return;
    }
    this.addEventListener('click', this.openViewer.bind(this));
    const url = new URL(window.location.href);
    if(url.searchParams.has("bantoa")){
      this.openViewer(this);
    }
  }

  addParameterToUrl(){
    const url = new URL(window.location.href);
    url.searchParams.append("bantoa", "bantoa");
    window.history.pushState({}, '', url)
  }

  openViewer = (base64Img) => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaSearch: Bantoa tracker is not loaded.");
      window.addEventListener(Bantoa.EVENTS.LOADED, () => this.openViewer(base64Img));
      return;
    }
    bnt_r_ai('visual', 'modal', {
	    quality: '0.75',
	    max_results: 100,
	    min_results: 1,
	    position: this.dataset.position,
	  });
    const url = new URL(window.location.href);
    if(!url.searchParams.has("bantoa")){
      this.addParameterToUrl();
    }
  }
}
customElements.define("bantoa-search", BantoaSearch);

// Web Component: BantoaProductSearch
// Gestisce la ricerca visuale per un prodotto specifico tramite SKU, verificare disponibilità e lanciare visual search.
// Attributi accettati:
//   - data-sku: SKU del prodotto per la ricerca visuale
//   - data-position: posizione da tracciare per l'analytics
//   - data-variant: (opzionale) variante per filtrare i risultati
// Eventi emessi: nessuno
// Dipendenze: window.isBantoaLoaded, Bantoa.EVENTS.LOADED, axios, bnt_r_ai
// Limiti: richiede che il tracker Bantoa sia caricato, necessita SKU valido
// Utilizzo: usato nella pagina prodotto per attivare la ricerca visuale Bantoa per un prodotto
class BantoaProductSearch extends HTMLElement {

  connectedCallback() {
    if(!this.dataset.sku) {
      console.error("BantoaProductSearch: No SKU found in the element.");
      return;
    }
    if(!this.dataset.position){
      console.error("BantoaSearch: No position found in the element.");
      return;
    }
    if(window.isBantoaLoaded)
      this.init();
    window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
    this.checkExists();
  }

  checkExists = () => {
    axios({
      url: `https://api.bantoa.com/api/visual?apikey=NTE4X2JhbnRvYWtleQ==&onlycheckexist=1&code=${this.dataset.sku}&tm=1751548151`,
      method: 'get',
    }).then(r => {
      if(r.data.productexist == 'ok'){
        this.classList.remove('d-none');
      }
    })
    .catch(e => {
      console.error("BantoaProductSearch: Error checking product existence", e);
    });
  }

  init = () => {
    this.addEventListener('click', this.openViewer.bind(this));
  }

  openViewer = () => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaSearch: Bantoa tracker is not loaded.");
      return;
    }
    const data = {
	    item: this.dataset.sku,
	    quality: '0.75',
	    max_results: 100,
	    min_results: 1,
	    position: this.dataset.position,
    };
    if(this.dataset.variant){
      data.filter = {
        sizes: this.dataset.variant
      };
    }
    bnt_r_ai('visual', 'modal', data);
  }
}
customElements.define("bantoa-product-search", BantoaProductSearch);


class BantoaCarouselOld extends CustomCarousel {
  #config;
  bantoaProducts;

  connectedCallback() {
    setTimeout(() => {
      const script = this.querySelector('script[data-config]');
      if(!script) {
        console.error("BantoaList: No configuration script found.");
        return;
      }
      this.#config = JSON.parse(script.textContent);
      console.log("BantoaList: Configuration loaded", this.#config);

      window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
      if(window.isBantoaLoaded)
        this.init();
    });
  }

  init = () => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaList: Bantoa tracker is not loaded.");
      return;
    }
    bnt_r_ai(this.#config.type, this.#config.src, this.#config.options).then(data => {
      console.log("BantoaList: Data received", data);
      this.bantoaProducts = data.data?.products || [];
      this.start();
    }).catch(err => {
      console.error('Visual-data promise failed:', err);
    });
  } 

  start = () => {
    const skus = this.bantoaProducts.map(product => product.sku);
    this.getProducts(skus);
  }

  getTrackingProduct = (product) => {
    const p = this.bantoaProducts.find((prod) => prod.sku == product.metaGroupCode.value);
    product.trackingUrl = p?.trackingurl;
    product.sku = p?.sku || product.sku;
    return product;
  }

}

class BantoaCarousel extends HTMLElement {
  #config;
  #template;
  #products;
  #cards;

  connectedCallback() {
    setTimeout(() => {
      const script = this.querySelector('script[data-config]');
      if(!script) {
        console.error("BantoaList: No configuration script found.");
        return;
      }
      this.#config = JSON.parse(script.textContent);
      console.log("BantoaList: Configuration loaded", this.#config);

      this.#template = this.querySelector('template');
      if(!this.#template) {
        console.error("BantoaList: No template found for products.");
        return;
      }

      window.addEventListener(Bantoa.EVENTS.LOADED, this.init.bind(this));
      if(window.isBantoaLoaded)
        this.init();
    });
  }

  init = () => {
    if(!window.isBantoaLoaded) {
      console.error("BantoaList: Bantoa tracker is not loaded.");
      return;
    }
    bnt_r_ai(this.#config.type, this.#config.src, this.#config.options).then(data => {
      console.log("BantoaList: Data received", data);
      this.#products = data.data?.products || [];
      this.getCards();
    }).catch(err => {
      console.error('Visual-data promise failed:', err);
    });
  } 
  
  getCards = () => {
    Promise.all(this.#products.map(product => {
      return axios.get(`${product.directurl}?section_id=helper-card`).then(resp => resp.data)
    })).then(htmlList => {
      console.log("BantoaList: Product HTML received", htmlList);
      this.#cards = htmlList.map((html, i) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        doc.querySelectorAll('a').forEach(a => {
          if(a.href.includes(`products/`)){
            a.href = this.#products[i].trackingurl || a.href;
          }
        });
        return doc.body.innerHTML;
      });
      this.render();
    })
  }

  render = () => {
    const html = this.#template.innerHTML;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wrapper = doc.querySelector('[data-products]');
    if(!wrapper) {
      console.error('BantoaList: No wrapper found for products');
      return;
    }
    wrapper.innerHTML = this.#cards.join('');
    this.innerHTML = doc.body.innerHTML;
  }

  getTrackingProduct = (product) => {
    const p = this.bantoaProducts.find((prod) => prod.sku == product.metaGroupCode.value);
    product.trackingUrl = p?.trackingurl;
    product.sku = p?.sku || product.sku;
    return product;
  }
}
customElements.define("bantoa-carousel", BantoaCarousel);